import { Subject } from "rxjs";
import Api from "../service/api";
import { URLS } from "fire-wind-water";

class SdeData {
  constructor() {}

  isError(res, cn, fn) {
    if (res.result === 0) {
      cn(res.content);
    } else {
      if (fn) {
        fn(res);
      }
    }
  }

  getSeminar(instanceId) {
    const $s = new Subject();
    Api.getTopicTemplateSeminar({ instanceId }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data);
        $s.complete();
      });
    });
    return $s;
  }

  getConfig(o) {
    const $s = new Subject();
    Api.getTemplateConfig({
      tenantId: o.tenantId,
      configId: o.configId,
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data.info);
        $s.complete();
      });
    });
    return $s;
  }

  getMemberInfo(o) {
    const $s = new Subject();
    Api.getMyInfo({
      tenantId: o.tenantId,
      schemaId: o.schemaId,
      sess: o.sess,
      isTemplate: 1,
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data);
        $s.complete();
      });
    });
    return $s;
  }

  canRegisterNew(o) {
    const $s = new Subject();
    Api.canRegisterNew({
      instanceId: o.instanceId,
      formId: o.registerFormId,
      sess: o.sess,
      openId: o.openId,
      includeFormData: 1,
      needSignupUrl: 0,
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data);
        $s.complete();
      });
    });
    return $s;
  }

  seminarSiteBrowse(o) {
    Api.seminarSiteBrowse({
      sess: o.sess || "",
      openId: o.openId || "",
      tc: URLS.getURL("tc") || "",
      tenantId: o.tenantId,
      seminarId: o.seminarId,
    });
  }

  getInstanceStatus(o) {
    const $s = new Subject();
    Api.getInstanceStatus({
      instanceId: o.instanceId,
      tenantId: o.tenantId,
      moduleId: 3,
      type: "poster",
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data);
        $s.complete();
      });
    });
    return $s;
  }

  getInstanceUrl(o) {
    const $s = new Subject();
    Api.getInstanceUrl({
      instanceId: o.instanceId,
      tenantId: o.tenantId,
      moduleId: 3,
      type: "poster",
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(data);
        $s.complete();
      });
    });
    return $s;
  }

  getShortUrl(url) {
    const $s = new Subject();
    const m = window.$sk.template.get();
    Api.getShortUrl({
      withCreate: 1,
      realUrlList: [url],
      tenantId: m.common.tenantId,
    }).subscribe((res) => {
      this.isError(res, (data) => {
        $s.next(
          window.location.protocol + window.$sk.config.shortUrl + data[url]
        );
        $s.complete();
      });
    });
    return $s;
  }
}

export { SdeData };
